/* Web Push subscription helpers. */
import { api, API } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function currentPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "denied";
}

export async function getRegistration() {
  return await navigator.serviceWorker.ready;
}

/** Tell the service worker the API base so background sync knows where to POST. */
export function bindApiBaseToSW() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistration().then((reg) => {
    const active = reg?.active || navigator.serviceWorker.controller;
    active?.postMessage({ type: "SET_API_BASE", url: API });
  });
}

/** Register a Background Sync tag; caller can call this whenever items are enqueued. */
export async function registerBackgroundSync(tag = "nafe-sync") {
  try {
    const reg = await navigator.serviceWorker.ready;
    if ("sync" in reg) {
      await reg.sync.register(tag);
      return true;
    }
  } catch { /* not supported */ }
  return false;
}

/** Subscribe this device to web push and persist on the backend. */
export async function subscribePush() {
  if (!pushSupported()) throw new Error("Push não suportado neste navegador");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permissão negada");
  const reg = await getRegistration();
  const { data } = await api.get("/push/public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.key);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  }
  const j = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: j.endpoint,
    keys: j.keys,
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribePush() {
  const reg = await getRegistration();
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch {}
    await sub.unsubscribe();
  }
}

export async function isSubscribed() {
  if (!pushSupported()) return false;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  return !!sub;
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test", {});
  return data;
}
